import React from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
// Simple utility for class merging if not present, but I'll implement a basic version inline to be safe
// or assume standard tailwind usage. I'll just use template literals for simplicity here since I can't guarantee a utils file exists yet.
export function Button({
  className,
  variant = 'primary',
  fullWidth = false,
  children,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-stone-900 text-white hover:bg-stone-800 focus:ring-stone-900 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-transform duration-200',
    secondary: 'bg-emerald-800 text-white hover:bg-emerald-900 focus:ring-emerald-800 shadow-md',
    outline: 'border-2 border-stone-200 bg-transparent hover:bg-stone-50 text-stone-900'
  };
  const sizes = 'px-8 py-4 text-lg';
  const width = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Fire Meta Pixel AddToCart event
    const win = window as any;
    if (win.fbq) {
      win.fbq('track', 'AddToCart', {
        content_name: 'Semana Resuelta',
        content_ids: ['42965772992721'],
        content_type: 'product',
        value: 9990,
        currency: 'ARS'
      });
    }
    // Redirect to checkout URL
    window.open('https://argrutinas.com/cart/42965772992721:1', '_blank');
    // Call original onClick if provided
    if (onClick) onClick(e);
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes} ${width} ${className || ''}`} onClick={handleClick} {...props} data-id="element-309">
      {children}
    </button>;
}